import { k, useCss } from 'kremling'
import React from 'react'

import { TextInput } from '@components/mantine/text-input.component'
import { Switch } from '@components/radix/switch'
import { RichText } from '@components/rich-text/rich-text.component'
import { ChoiceBuilder } from '@src/pages/workflow/template/fields/choice-builder.component'

type FieldRadioProps = {
  field: Field
  onChange: (field: Field, debounce?: boolean) => void
  isRequired: boolean
  updateRequiredToggle: (value: boolean, fieldId: string) => void
}

export function FieldRadio({
  field,
  onChange,
  isRequired,
  updateRequiredToggle,
}: FieldRadioProps) {
  const scope = useCss(css)

  function updateFieldLabel(label: string) {
    if (label === field.label) return
    const updatedField = {
      ...field,
      label,
    }
    onChange(updatedField, true)
  }

  function updateFieldDescription(description: string) {
    const updatedField = {
      ...field,
      description,
    }
    onChange(updatedField)
  }

  function updateChoices(choices: string[]) {
    const updatedField = {
      ...field,
      choices,
    }
    onChange(updatedField)
  }

  return (
    <div
      {...scope}
      className="space-y-6"
    >
      <div className="flex items-center">
        <Switch
          id={`required-switch-${field.id}`}
          onChange={value => updateRequiredToggle(value, field.id)}
          className="mr-2"
          value={isRequired}
        />
        <label htmlFor={`required-switch-${field.id}`}>Required</label>
      </div>
      <div className="form-group mb-6">
        <TextInput
          label="Name the field"
          defaultValue={field.label}
          placeholder="e.g. Rate your experience"
          onChange={updateFieldLabel}
          autoFocus
        />
      </div>
      <div className="form-group">
        <label htmlFor="text-field-desc">Describe this field</label>
        <RichText
          id="text-field-desc"
          onChange={updateFieldDescription}
          initialValue={field ? field.description : null}
          placeholder="Type here..."
        />
      </div>
      <div className="form-group">
        <ChoiceBuilder
          onChange={updateChoices as any}
          field={field}
          title="Radio choices"
        />
      </div>
    </div>
  )
}

const css = k`

`
